import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { MultiFamilyStore } from '../stores';

export const useMultifamilyStore = () => useContext<{
  multiFamilyStore: MultiFamilyStore
}>(StoreContext);
